import MxFieldCarrusel from "@rf-l1/form/files-fields/carrusel/MxFieldCarrusel";
import { MxFieldCarruselProps } from "@rf-l1/form/files-fields/carrusel/MxFieldCarrusel";
import { useMxFieldControllerContext } from "@rf/context/MxFieldController";

type omit = "inputRef" | "invalid" | "name" | "value" | "onChange" | "onBlur";
export type MxFormCarruselFieldProps<T> = Omit<MxFieldCarruselProps, omit>;

const MxFormCarruselField = <T extends any>(props: MxFormCarruselFieldProps<T>) => {
  const { onBlur, onChange, inputRef, name, value, invalid, disabled, id } =
    useMxFieldControllerContext();
  const handleChange = (value: any) => {
    onChange(value);
    onBlur();
  };

  return (
    <MxFieldCarrusel {...props} value={value} onChange={handleChange} id={id} />
  );
};
export default MxFormCarruselField;
